module.exports = __webpack_public_path__ + "img/user.2c6e94aa.png";